import { useMessage } from '../web/useMessage';
const { createMessage } = useMessage();
class SheetWebsocket {
  constructor(props: string) {
    this.wsUrl = props;
    this.reconnectCount = 0;
    this.websocket = undefined;
    this.heartCheckInterval = null;
    this.reconnectTimer = null;
    this.connect();
  }
  private wsUrl: string = '';
  private reconnectCount: number = 0;
  websocket: WebSocket | undefined;
  private heartCheckInterval: NodeJS.Timer | null = null;
  private reconnectTimer: NodeJS.Timer | null = null;
  static timeout: number = 30000;
  // static timeout: number = 3000;
  static MaxRennectCount: number = 10;

  // 连接开始
  connect(): void {
    try {
      this.websocket = new WebSocket(this.wsUrl);
      this.initEventHandle();
    } catch (error) {
      console.log('连接错误', error);
      createMessage.error('websocket连接失败');
    }
  }
  onmessage = (data: any) => data;
  // event
  initEventHandle() {
    const that = this;
    this.websocket!.onclose = (event: Recordable) => {
      console.log('连接关闭', event);
      this.resetTimer();
      if (event.code !== 1000) {
        // 手动断开
        this.reconnectTimer = setTimeout(() => {
          this.reconnect();
        }, 1000);
      }
      // createMessage.error("websocket已关闭");
    };
    this.websocket!.onerror = () => {
      console.log('连接失败');

      this.reconnectTimer = setTimeout(() => {
        that.reconnect();
      }, 1000);
    };
    this.websocket!.onopen = () => {
      console.log('连接成功');
      // 连接成功主动请求一次
      this.send(JSON.stringify({ type: 'sheetNum' }));
      //心跳检测重置
      that.heartCheck();
    };
    this.websocket!.onmessage = (event: Recordable) => {
      this.onmessage(event);
      that.heartCheck();
    };
  }
  // 重连
  reconnect = () => {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    this.reconnectCount++;
    if (this.reconnectCount > SheetWebsocket.MaxRennectCount) {
      // 重连超过10次
      this.close();
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
      createMessage.error('websocket重连次数已上限');
      return false;
    }
    this.connect();
    console.log('正在重连');
  };
  // 发送信息
  send(msg: string): void {
    this.websocket!.send(msg);
  }
  // 心跳检测
  heartCheck() {
    if (this.heartCheckInterval) return false;
    this.heartCheckInterval = setInterval(() => {
      if (this.websocket?.readyState === 1) {
        this.send(JSON.stringify({ type: 'heartbeat' }));
      } else {
        this.close();
      }
    }, SheetWebsocket.timeout);
  }
  // 关闭websocket
  close() {
    this.websocket && this.websocket.close(1000, 'leave close');
    this.resetTimer();
  }
  // 重置
  resetTimer() {
    if (this.heartCheckInterval) {
      clearInterval(this.heartCheckInterval);
      this.heartCheckInterval = null;
    }
  }
}

export default SheetWebsocket;
